export default __webpack_public_path__ + "static/media/technology-433mhz.353dd256.svg";